import { render, staticRenderFns } from "./vipDetailAccount.vue?vue&type=template&id=054dad2a&scoped=true"
import script from "./vipDetailAccount.vue?vue&type=script&lang=js"
export * from "./vipDetailAccount.vue?vue&type=script&lang=js"
import style0 from "./vipDetailAccount.vue?vue&type=style&index=0&id=054dad2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054dad2a",
  null
  
)

export default component.exports